import type {TMedicine, TMedicineRp} from '@app/types';
import {useMemo} from 'react';

const RP_KEYS = [
  'rp_number',
  'rp_directions',
  'rp_type',
  'rp_intake_unit',
  'rp_intake_frequency',
  'rp_intake_per_day',
] as const;

const filterNull = (value: string) => (value !== 'null' ? value : undefined);

export default function useRpMedicines(medicines?: TMedicine[]): TMedicineRp[] {
  const groupedMedicines = useMemo(() => {
    return (medicines ?? []).reduce(
      (acc: Record<string, TMedicine[]>, medicine: TMedicine) => {
        const key = RP_KEYS.map((k) => medicine[k]).join('|');
        acc[key] = acc[key] || [];
        acc[key].push(medicine);
        return acc;
      },
      {},
    );
  }, [medicines]);

  const rpMedicines = useMemo(() => {
    return Object.entries(groupedMedicines).map(([key, items]) => {
      const rpValues = key.split('|').map(filterNull);
      const rpFields = Object.fromEntries(
        RP_KEYS.map((rpKey, index) => [rpKey, rpValues[index]]),
      );
      return {
        ...rpFields,
        rp_intake_frequency: rpFields.rp_intake_frequency
          ? Number.parseInt(rpFields.rp_intake_frequency)
          : undefined,
        rp_intake_per_day: rpFields.rp_intake_per_day
          ? Number.parseInt(rpFields.rp_intake_per_day)
          : undefined,
        medicines: items,
      };
    });
  }, [groupedMedicines]);

  return rpMedicines;
}
